import React from 'react';
import { compose, mergeDeepRight } from 'ramda';
import { connect } from 'react-redux';

import styleFile from './MonoHotelAvailSummary.js';
import { RichText, Button } from '@synergycms_core/components/generic/';
import Price from '@synergycms_core/components/generic/Price';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import actions from '../../../store/actions';
import Image from '@synergycms_core/components/generic/Image';
import { withThemeJSS } from 'synergycms_core/src/components/providers/themeProvider';

const TotalAmount = props =>
  props.segmentsFilled > 0 && (
    <div className={props.classes.totalAmount}>
      <RichText innerStyle={['roboto11SoftGray', 'uppercase']} text="_%total estancia%_" translate={true} />
      <Price amount={props.totalAmount} innerStyle={['monoHotelPrice', 'bold']} />
    </div>
  );

const MonoHotelAvailSummary = class MonoHotelAvailSummary extends React.Component {
  static displayName = 'MonoHotelAvailSummary';
  constructor(props) {
    super(props);
    this.state = {
      showTooltipHelp: true
    };
    this.onNextClick = this.props.config.onNextClick.bind(this);
  }

  closeTooltipHelp = () => {
    this.setState(state =>
      mergeDeepRight(state, {
        showTooltipHelp: false
      })
    );
  };

  render() {
    const { config, theme } = this.props,
      { roomRatesSelected, totalSegments, showTaxes, segmentsFilled, hasSelectionAvail, selection } = config,
      totalAmount = roomRatesSelected.reduce(
        (totalAmount, roomRate) => (showTaxes ? roomRate.get('price_tax', 0) : roomRate.get('price', 0)) + totalAmount,
        0
      );
    const { classes } = theme.styles;
    if (totalSegments > 1 && totalSegments === segmentsFilled) {
      setTimeout(() => {
        this.closeTooltipHelp();
      }, 3000);
    }

    return (
      <div className={totalSegments > 1 || (!selection && hasSelectionAvail) ? classes.defaultStyle : classes.hide}>
        <div className={classes.content}>
          <div className={classes.contLeft}>
            <div className={classes.firstColumn}>
              <RichText
                innerStyle={
                  segmentsFilled === 0
                    ? ['roboto24Black', 'white', 'circleSecond', 'disabled']
                    : ['roboto24Black', 'white', 'circleSecond', 'enabled']
                }
                text={segmentsFilled.toString()}
              />
              <RichText
                innerStyle={['roomOf']}
                text={'_%habitación%_'}
                translate={true}
                ucFirst={true}
                // el zero sempre hauria de mostrar plural? crec que si
                plural={segmentsFilled === 0 ? 2 : segmentsFilled}
              />{' '}
              <RichText innerStyle={['roomOf']} text={'_%de%_'} translate={true} />
              <RichText innerStyle={['roomNumber']} text={' ' + totalSegments} />
            </div>
            <TotalAmount segmentsFilled={segmentsFilled} totalAmount={totalAmount} classes={classes} />
          </div>
          <div className={classes.contRight}>
            <Button
              id={'td-d1-continue-multiroom-00'}
              onClick={this.onNextClick}
              innerStyle={['toggleSecondButton', 'summary',classes.robotoSummary]}
              disabled={segmentsFilled !== totalSegments}
              ariaLabel={"_%siguiente%_"}
              translate={true}>
              <RichText
                rightIcon={{ unicodeContent: config.langCode === 'AR' ? '005C' : 'e000', innerStyle: ['size12', 'marginLeft14'] }}
                text={'_%siguiente%_'}
                translate={true}
                ucFirst={true}
              />
            </Button>
          </div>
        </div>
        {this.state.showTooltipHelp && totalSegments === segmentsFilled && (
          <div className={classes.tooltipHelpContainer}>
            <div className={classes.tooltipHelp} onClick={this.closeTooltipHelp}>
              <div className={classes.tooltipHelpCloseContainer}>
                <div className={classes.tooltipHelpClose}>
                  <Button onClick={this.closeTooltipHelp} ariaLabel={"_%cerrar%_"} translate={true}>
                    <Image unicodeContent={'e020'} innerStyle={['size10']} />
                  </Button>
                </div>
              </div>
              <RichText
                text={'_%ya puedes pasar al siguiente paso%_'}
                translate={true}
                ucFirst={true}
                innerStyle={['roboto13Black']}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
};

const mapDispatchToProps = dispatch => {
  return {
    onNextClick: e => {
      e && e.preventDefault();
      dispatch(actions.events.trigger('next_step_1'));
      dispatch(actions.customer.header.show('engine', false));
      dispatch(actions.customer.step.next());
      dispatch(actions.router.update());
    }
  };
};

const mapStateToProps = (store, ownProps) => {
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const hotelInfo = store.getIn(['hotels', hotelId]);
  const selection = store.getIn(['customer','params','params','selection_avail'],null);

  return {
    staticRooms: store.getIn(['hotels', hotelId, 'rooms']),
    showTaxes: hotelInfo.get('show_taxes'),
    langCode: store.getIn(['customer', 'lang_info', 'code']),
    hasSelectionAvail: store.getIn(['customer', 'params', 'params', 'selection_avail'], null),
    selection: selection,
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  PropertyManager(['roomRatesSelected', 'totalSegments', 'onNextClick', 'showTaxes', 'segmentsFilled', 'langCode', 'hasSelectionAvail','selection']),
  withThemeJSS({ styleFile, link: true })
)(MonoHotelAvailSummary);
